import { render, staticRenderFns } from "./ShortVideos.vue?vue&type=template&id=61e9c2c0&scoped=true"
import script from "./ShortVideos.vue?vue&type=script&lang=js"
export * from "./ShortVideos.vue?vue&type=script&lang=js"
import style0 from "./ShortVideos.vue?vue&type=style&index=0&id=61e9c2c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e9c2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e9c2c0')) {
      api.createRecord('61e9c2c0', component.options)
    } else {
      api.reload('61e9c2c0', component.options)
    }
    module.hot.accept("./ShortVideos.vue?vue&type=template&id=61e9c2c0&scoped=true", function () {
      api.rerender('61e9c2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ShortVideos.vue"
export default component.exports